import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const ExclamationMark = ({ color = '#313634', ...rest }: Props) => {
  return (
    <Svg
      width={21}
      height={21}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="error_FILL0_wght400_GRAD0_opsz48 1">
        <path
          id="Vector"
          d="M10.4996 14.875C10.704 14.875 10.8755 14.8059 11.0141 14.6676C11.1526 14.5293 11.2219 14.3579 11.2219 14.1535C11.2219 13.9491 11.1527 13.7776 11.0145 13.6391C10.8762 13.5005 10.7048 13.4312 10.5004 13.4312C10.296 13.4312 10.1245 13.5004 9.98594 13.6387C9.8474 13.777 9.77812 13.9483 9.77812 14.1527C9.77812 14.3572 9.84726 14.5286 9.98554 14.6672C10.1238 14.8057 10.2952 14.875 10.4996 14.875ZM9.90938 11.5281H11.2219V5.99375H9.90938V11.5281ZM10.5058 19.25C9.29928 19.25 8.16543 19.0203 7.10426 18.5609C6.04309 18.1016 5.1151 17.4745 4.32031 16.6797C3.52552 15.8849 2.89844 14.9564 2.43906 13.8941C1.97969 12.8319 1.75 11.6968 1.75 10.4891C1.75 9.28129 1.97969 8.14627 2.43906 7.08402C2.89844 6.02176 3.52552 5.09687 4.32031 4.30938C5.1151 3.52188 6.04363 2.89844 7.1059 2.43906C8.16815 1.97969 9.30316 1.75 10.5109 1.75C11.7187 1.75 12.8537 1.97969 13.916 2.43906C14.9782 2.89844 15.9031 3.52188 16.6906 4.30938C17.4781 5.09687 18.1016 6.02292 18.5609 7.0875C19.0203 8.15208 19.25 9.28764 19.25 10.4942C19.25 11.7007 19.0203 12.8346 18.5609 13.8957C18.1016 14.9569 17.4781 15.8836 16.6906 16.6757C15.9031 17.4678 14.9771 18.0949 13.9125 18.5569C12.8479 19.019 11.7124 19.25 10.5058 19.25ZM10.5109 17.9375C12.5745 17.9375 14.3281 17.212 15.7719 15.7609C17.2156 14.3099 17.9375 12.5526 17.9375 10.4891C17.9375 8.42552 17.217 6.67188 15.776 5.22812C14.335 3.78437 12.5763 3.0625 10.5 3.0625C8.44375 3.0625 6.6901 3.783 5.23906 5.22401C3.78802 6.66504 3.0625 8.4237 3.0625 10.5C3.0625 12.5562 3.78802 14.3099 5.23906 15.7609C6.6901 17.212 8.4474 17.9375 10.5109 17.9375Z"
          fill={color}
        />
      </g>
    </Svg>
  )
}

export default ExclamationMark
